import { Resources } from './resources';
import { Pages } from './pages';
import { Search } from './search';
import { ProfilePage } from "./my_profile";
import { JobsPage } from "./jobs";
import { AssessmentsIndexPage } from "./assessments";
import { Contact } from "./contact_us";

export default [
	...Resources,
	...Pages,
    ...Search,
    ...ProfilePage,
    ...JobsPage,
    ...AssessmentsIndexPage,
    ...Contact
]



// WEBPACK FOOTER //
// ./resources/assets/js/views/views.js